import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Field } from 'redux-form'
import ActivePromo from './ActivePromo'

const ActivePromotions = ({ fields, removePromo }) => (
  <Wrapper>
    <LabelText>Potential Savings:</LabelText>

    <PromotionsList>
      {fields.getAll().map((promotion, index) => (
        <li key={ promotion.promotionId }>
          <Field
            name={ promotion.promotionId }
            component={ ActivePromo }
            defaultData={ promotion }
            title="Promotion"
            removePromotion={ () => removePromo(index) }
            promotion />
        </li>
      ))}
    </PromotionsList>
  </Wrapper>
)

ActivePromotions.propTypes = {
  fields: PropTypes.shape(),
  removePromo: PropTypes.func
}

export default ActivePromotions

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  width: 100%;
  margin: 0 0 30px 0;
`

const LabelText = styled.p`
  margin: 0 10px 0 0;
  padding: 0;
`

const PromotionsList = styled.ul`
  margin: 0;
  padding: 0;
`
